<!--公司介绍-->
<template>
  <div class="about2">
    <!--顶部介绍-->
    <picture>
      <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">
      <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">
      <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">
    </picture>
    <guide :guide="guide" :color="'rgb(90, 137, 227)'" style="position: relative;top: 2rem;"></guide>
    <!--不要删！！！！！！！！！！！！！！！！！！！！！-->
    <!--主体内容-->
    <!--<div class="x-container">-->
      <!--<div class="x-title">合作咨询</div>-->
      <!--<section>-->
        <!--<p style="width: 80%;margin: auto;text-align: left">若您有工程项目需要合作或者咨询，请填写如下信息，提交后资深项目经理将按照反馈时间尽快与您联系。</p>-->
      <!--</section>-->
      <!--&lt;!&ndash;表单&ndash;&gt;-->
      <!--<section class="connect">-->
        <!--<el-form class="form" :model="form" :label-position='labelPosition' :inline="true">-->
          <!--<el-row>-->
            <!--<el-col :span="12" :xs="24" :sm="24" :md="12">-->
              <!--<el-form-item label-width="5rem" label="联系人">-->
                <!--<el-input placeholder="必填" v-model="form.name"></el-input>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="12" :xs="24" :sm="24" :md="12">-->
              <!--<el-form-item label-width="5rem" label="手机号码">-->
                <!--<el-input placeholder="必填" v-model="form.phone"></el-input>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          <!--</el-row>-->
          <!--<div>-->
            <!--<el-form-item class="textarea" style="width: 100%" label-width="100%" :inline="false" label="咨询备注信息">-->
              <!--<el-input placeholder="例1:有个酒店的工程..." type="textarea" v-model="form.description"></el-input>-->
            <!--</el-form-item>-->
          <!--</div>-->
          <!--<div style="text-align: center">-->
            <!--<span class="x-btn">提交</span>-->
          <!--</div>-->
        <!--</el-form>-->
      <!--</section>-->
    <!--</div>-->
    <!--联系我们蓝色图片-->
    <section class="blueBackground" style="margin-top: 5rem">
    </section>
    <!--联系方式-->
    <div class="x-container contact">
      <div class="left">
        <ul>
          <li>
            <span>公司地址:</span>
            <span>广东省珠海市香洲区前山金鸡西路</span>
          </li>
          <li>
            <span>办公电话:</span>
            <span>0756-8579928</span>
          </li>
          <li>
            <span>企业邮箱:</span>
            <span>green_tech@cn.gree.com</span>
          </li>
        </ul>
      </div>
      <!--暂不开放公众号-->
      <!--<div class="right">-->
      <!--  <picture>-->
      <!--      <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/pic2.png">-->
      <!--      <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/pic2.png">-->
      <!--      <img src="@/assets/img/pc/about/about2/pic2.png">-->
      <!--  </picture>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'

  export default {
    name: "solution1",
    components: {
      guide,
    },
    data() {
      return {
        guide: [
          // {label: '格力智能楼宇'},
          {label: '关于我们'},
          {label: '联系我们'},
        ],
        labelPosition: "left",
        form: {
          name: '',
          phone: '',
          description: '',
        }
      }
    },
    methods: {},
    mounted() {
    }
  }
</script>

<style scoped lang="less">
  .x-top {
    padding: 0;
    min-height: 23rem;
    .x-top-img {
      text-align: right;
      img {
        width: 20rem;
      }
    }
  }

  /*表格*/
  .form {
    margin: auto;
    width: 80%;
    padding: 2rem;
    text-align: left;
    box-sizing: border-box;
    .top {
      input {
        width: 40%;
      }
    }
    /*了解更多按钮*/
    .x-btn {
      text-align: center;
      display: inline-block;
      color: #fff;
      background-image: linear-gradient(to right, rgb(112, 68, 249), rgb(84, 106, 238));
      width: 3rem;
      border-radius: 50px;
      padding: 0.5rem 2rem 0.5rem 2rem;
      margin-top: 3rem;
      cursor: pointer;
    }
  }

  /*头部背景图*/
  .bakTop {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
  /*联系我们蓝色图*/
  .blueBackground{
    background-color: @blue;
    height: 13rem;
    background-image: url("../../../assets/img/pc/about/about2/pic1.png");
    background-repeat: no-repeat;
    background-position: center center;
  }
  @media screen and (min-width: 320px){
    .blueBackground{
      background-image: url("../../../assets/img/mobile/about/about2/pic1.png")!important;
    }
  }
  @media screen and (min-width: 1024px){
    .blueBackground{
      background-image: url("../../../assets/img/pc/about/about2/pic1.png")!important;
    }
  }
  /*联系我们*/
  .contact{
    display: flex;
    justify-content: space-between;
    ul{
      li{
       text-align: left;
        line-height: 3rem;
        span{
          word-break: break-all
        }
      }
    }
  }

</style>
<style lang="less">
  .x-container {
    .connect {
      .el-form--inline .el-form-item__label {
        color: @deepblue;
        font-size: 1rem;
      }
      .el-input__inner {
        border: 1px solid @blue;
        border-radius: 0;
      }
      .el-form--inline .el-form-item__content {
        /*width: 100%;*/
      }
      .el-textarea__inner {
        min-height: 10rem !important;
        border: 1px solid @blue;
        border-radius: 0;
      }
      .textarea {
        .el-form-item__content {
          width: 100%;
        }
        .el-form-item__label {
          margin-bottom: 1rem;
        }
      }
    }
  }
</style>

